define( [ "./selector-sizzle" ], function() {} );



// WEBPACK FOOTER //
// ./~/jquery/src/selector.js